module.exports = __webpack_public_path__ + "img/52ne.e93cec27.svg";